import login from '../api/auth/wx-login'
import store from '../store'
import router from '../router'
import {OBTAIN_AUTHENTICATION, SET_ACCOUNT} from '../store/mutation-types'
import {alert} from '../utils/dlg'

const RESULT_OK = 0
const RESULT_INVALID_CODE = 1
const RESULT_NOT_BIND = 2
const RESULT_INVALID_USER = 3

export default {
  beforeRouteEnter (to, from, next) {
    let code = to.query.code
    let state = to.query.state
    login(code, state, ({body: {result, msg, token, account, openid}}) => {
      switch (result) {
        case RESULT_OK:
          store.commit(OBTAIN_AUTHENTICATION, token)
          store.commit(SET_ACCOUNT, account)
          router.push({name: 'Service'})
          break
        case RESULT_INVALID_CODE:
          alert(msg)
          break
        case RESULT_NOT_BIND:
        case RESULT_INVALID_USER:
          alert(msg, () => {
            router.push({name: 'Login', params: {openid: openid}})
          })
      }
    }, (error) => {
      alert(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/wx-token-getter.js